import "./bookingLoaders.css";

/** Animated document with a turning page. Shown while the shipment is booked. */
function BookShipmentBookingLoading() {
  return <span className="booking-shipment-loader" />;
}

export default BookShipmentBookingLoading;
